import { MicOff } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function MicOffIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <MicOff
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
